import { useContext } from 'react';
import BankContext, { BankContextInterface } from '../BankContext';

export const useBankContext = (): BankContextInterface => {
  const bankContext = useContext(BankContext);
  if (!bankContext) {
    throw new Error('useBankContext must be used within a BankProvider');
  }
  return bankContext;
};
